export default __webpack_public_path__ + "static/media/logo_en.66d00e98.svg";